export default class PaymentTerms {
  constructor(el) {
    this._el = el;
    this._reference = this._el.querySelector('[data-payment-terms-reference]');
    this._paymentTerms = this._el.querySelector('shopify-payment-terms');
    this._target = this._el.querySelector('[data-payment-terms-target]');

    if (!this._paymentTerms) return;

    if (!this._target) {
      this._reference.style.display = null;
    } else {
      this._input = document.createElement('input');
      this._input.name = 'id';
      this._input.type = 'hidden';

      this._target.appendChild(this._input);
      this._target.appendChild(this._paymentTerms);
      this._target.style.display = null;
    }
  }

  update(variantId) {
    if (!this._paymentTerms || !this._target) return;
    this._input.value = variantId;
    this._input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
